export const Constants = {
	AUTH_SOURCE_KEY: 'amplify-react-auth-source',
	AUTH0: 'auth0',
	GOOGLE: 'google',
	FACEBOOK: 'facebook',
	AMAZON: 'amazon',
	REDIRECTED_FROM_HOSTED_UI: 'amplify-redirected-from-hosted-ui',
};
